module.exports = __webpack_public_path__ + "img/329.2d7caf91.jpg";